const services = () => [
  { text: `Motoristas`, value: `driver` },
  { text: `Ofertas`, value: `offer` },
  { text: `Proprietários`, value: `provider` },
  { text: `Veículos`, value: `vehicle` },
  { text: `Chat`, value: `chat` },
  { text: `Ranking`, value: `ranking` },
  { text: `Usuários`, value: `user` },
  { text: `Filiais`, value: `branch` },
  // { text: ``, value: `` },
]

export default services()